const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trade Global Commodities — The Smarter Way</h1>
        <p>
          The commodities market connects traders with some of the most
          in-demand assets driving the global economy from precious metals to
          energy and agricultural products. At The Pips, you can speculate on
          the price movements of Gold, Silver, Brent Crude, WTI, and more with
          tight spreads, flexible leverage, and real-time data analytics.

          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
